// extracted by mini-css-extract-plugin
export default {"formControl":"Form_formControl__bpStn","formPenaltyControl":"Form_formPenaltyControl__D03qe"};